export default __webpack_public_path__ + "static/media/setting-1.9626b9fa.svg";